import React from 'react';

const ResizeHandle = ({ onMouseDown }) => (
  <>
    {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
    <div
      className="table-resize-handle"
      onMouseDown={onMouseDown}
      title="Drag to resize table height"
    >
      <div className="table-resize-handle-grip" />
    </div>

    <style>{`
      .table-resize-handle {
        height: 8px;
        cursor: row-resize;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fafafa;
        border: 1px solid #f0f0f0;
        border-top: none;
        border-radius: 0 0 4px 4px;
        transition: background 0.2s;
      }
      .table-resize-handle:hover {
        background: #e6f4ff;
      }
      .table-resize-handle-grip {
        width: 36px;
        height: 3px;
        border-radius: 2px;
        background: #d9d9d9;
        transition: background 0.2s;
      }
      .table-resize-handle:hover .table-resize-handle-grip {
        background: #1890ff;
      }
    `}</style>
  </>
);

export default ResizeHandle;
